import { Box, ColorOptions, SpacerNew } from '@jfs/ui-new'
import { KeyValue } from '../../../comps/KeyValuePairs'
import { Title } from '../../../comps/Title'
import { addCountryCode, getFormattedAmount, getMaskedAccountNumber, returnDateString } from '../../../util/utill'
import { getRRNNo } from '../SplittedTnxListScreen/FundTransferStatus'
import { DomesticMoneyTransferStrings } from '../Strings'
import { TransactionId } from '../TransactionSuccessful/TransactionId'

export const FORM_FIELDS = {
  SEND_TEXT: 'sendText',
  TRANSACTION_ID: 'transactionId',
  SPACER: 'spacer',
  CONFIRM_DATA: 'confirmData',
}

interface TransactionSuccessForm {
  transactionId: string
  transactionData: any
  transferredAmount: number
  transactionStatus: string
  transactionResponseCode: string | null
}

const colorMapper = {
  PROCESSED: 'GREEN',
  SUCCESS: 'GREEN',
  PENDING: 'ORANGE',
  FAILED: 'RED',
}

export const TransactionSuccessForm = ({ splittedTnxResponses, fetchStatus, download }) => {
  const formItems: any[] = []
  formItems.push({
    fieldName: FORM_FIELDS.SEND_TEXT,
    ComponentName: Title,
    title: 'Transaction Details',
  })

  console.log('htag splittedTnxResponses', splittedTnxResponses)
  const transactions = splittedTnxResponses.flatMap((item) => {
    return {
      ...item,
      ...(item.responseData?.transactions?.[0] ?? {}),
    }
  })
  console.log('htag transactions', transactions)

  transactions.forEach((element, index) => {
    if (index > 0) {
      formItems.push({
        fieldName: FORM_FIELDS.SPACER,
        ComponentName: SpacerNew,
        size: 5,
      })
      formItems.push({
        fieldName: FORM_FIELDS.SPACER,
        ComponentName: Box,
        height: 1,
        width: '100%',
        backgroundColor: 'GRAY_BORDER' as ColorOptions,
      })
      formItems.push({
        fieldName: FORM_FIELDS.SPACER,
        ComponentName: SpacerNew,
        size: 5,
      })
    }
    formItems.push({
      fieldName: `${FORM_FIELDS.TRANSACTION_ID}_${index}`,
      ComponentName: TransactionId,
      transactionId: element.transactionId,
      hide: !element.transactionId,
    })
    formItems.push({
      fieldName: FORM_FIELDS.SPACER,
      ComponentName: SpacerNew,
      size: 10,
    })
    //"ICON_REFRESH"
    const rrnNo = getRRNNo(element)
    const transactionData = element?.errMessage
      ? {
        'Idempotent Key': element.idempotentKey,
        'Error Reason': element?.errMessage,
      }
      : {
        ...(rrnNo && rrnNo !== 'null'
          ? {
            'RRN No.': {
              text: `${rrnNo}`,
              iconId: 'DOWNLOAD',
              onPress: () => {
                download(rrnNo)
              },
            },
          }
          : {}),
        'Gross Amount': `${getFormattedAmount(element?.amount)}`,
        'Date & Time': returnDateString(element.timestamp ?? ''),
        'Mobile No.': addCountryCode(element?.responseData?.remitterMobile),
        'Beneficiary Name': element?.responseData?.beneficiaryName,
        'Account Number': getMaskedAccountNumber(element?.responseData?.beneficiaryAccountNumber ?? ''),
        'Bank IFSC': element?.responseData?.beneficiaryBankName,
        'Transaction Status': {
          text: element?.status ?? 'FAILED',
          color: colorMapper[element?.status ?? 'FAILED'],
          ...(element?.status === 'PENDING'
            ? {
              iconId: 'ICON_REFRESH',
              onPress: () => {
                fetchStatus(element?.idempotentKey)
              },
            }
            : {}),
        },
        ...(!element?.status || element?.status === 'FAILED'
          ? (() => {
            console.log("Checking Error Message:", element?.error?.message);
            console.log("Checking Response Message:", element?.responseMessage);
            return {
              'Failure Reason': {
                text: element?.error?.message || (element?.responseMessage === 'SUCCESS'? '' : element?.responseMessage ),
                color: 'RED'
              },
            };
          })()
          : {}),
        // ...(!element?.status || element?.status === 'FAILED'
        //   ? {
        //       'Failure Reason': { text: element?.error?.message || element?.responseMessage, color: 'RED' },
        //     }
        //   : {}),
      }
    formItems.push({
      fieldName: FORM_FIELDS.CONFIRM_DATA,
      ComponentName: KeyValue,
      placeholder: DomesticMoneyTransferStrings.amount,
      data: transactionData,
    })
  })
  console.log('htag formItems', formItems)
  return [
    {
      horizontalSpacing: 12,
      formItems: formItems,
      onSubmit: () => {
        return 'end'
      },
    },
  ]
}
